import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class GoogleIdentityService {
  private initialized = false;

  async load() {
    // Várjuk, amíg a Google SDK betöltődik
    await new Promise<void>((resolve) => {
      const check = () => {
        if (window.google?.accounts?.id) {
          resolve();
        } else {
          setTimeout(check, 50);
        }
      };
      check();
    });
  }

  initialize(clientId: string, callback: (token: string) => void) {
    if (this.initialized) return;
    this.initialized = true;

    window.google.accounts.id.initialize({
      client_id: clientId,
      callback: (response: any) => {
        // Visszakapod az ID tokent
        callback(response.credential);
      },
      use_fedcm_for_prompt: true,  // 🔹 FedCM-opt-in
      use_fedcm_for_button: true,  // 🔹 FedCM-opt-in
      cancel_on_tap_outside: false,
    });
  }

  renderButton(container: HTMLElement) {
    const width = container.offsetWidth;    
    window.google.accounts.id.renderButton(container, {
      type: 'standard',
      theme: 'outline',
      size: 'large',
      text: 'continue_with',
      shape: 'rectangular',
      width: width
    });
  }

  prompt() {
    window.google.accounts.id.prompt(); // FedCM prompt (One Tap UI)
  }
}
